import { Loader2Icon } from "lucide-react"
import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner";
import { MdInfo } from "react-icons/md";

/** @type {React.FC<import("sonner").ToasterProps>} */
const Toaster = ({
  ...props
}) => {
  const { resolvedTheme } = useTheme()
  const isDark = resolvedTheme === "dark"

  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:rounded-xl group-[.toaster]:p-4 !items-start !grid !grid-cols-[auto_1fr_max-content_max-content] !gap-x-3 !gap-y-3",
          title: "!col-start-2 !font-medium !text-[15px] !font-sans !pr-8",
          description: "!text-muted-foreground !font-normal !text-[13px] !font-sans !mt-0.5 !leading-snug",
          cancelButton: "!col-start-3 !row-start-2 !bg-muted !text-muted-foreground hover:!bg-muted/80 !font-medium !text-[16px] !h-8 !px-3 !rounded-md !font-sans !m-0 !w-auto !justify-center",
          closeButton: "!absolute !right-3 !top-3 !left-auto !bottom-auto !transform-none !text-muted-foreground hover:!text-foreground !bg-transparent hover:!bg-muted !border-0 !w-6 !h-6 !min-w-0 !min-h-0 !flex !items-center !justify-center !font-md !font-bold",
          content: "!col-start-2 !col-span-3 !row-start-1 !items-start !text-left !flex !flex-col !w-full",
          actionButton: "!col-start-4 !row-start-2 !bg-primary !text-primary-foreground hover:!bg-primary/90 !font-medium !text-[13px] !h-8 !px-3 !rounded-md !font-sans !m-0 !w-auto !justify-center",
          icon: "!col-start-1 !row-start-1 !items-start !mt-0.5",
        },
      }}
      icons={{
        success: <div className="flex items-center gap-1.5"><MdInfo className="size-[20px] text-green-500" /></div>,
        info: <div className="flex items-center gap-1.5"><MdInfo className="size-[20px] text-blue-500" /></div>,
        warning: <div className="flex items-center gap-1.5"><MdInfo className="size-[20px] text-yellow-500" /></div>,
        error: <div className="flex items-center gap-1.5"><MdInfo className="size-[20px] text-destructive" /></div>,
      }}
      style={
        isDark
          ? {
            "--normal-bg": "#0A0A0A",
            "--normal-text": "#FFFFFF",
            "--normal-border": "#202020",
            "--border-radius": "12px"
          }
          : {
            "--normal-bg": "#FFFFFF",
            "--normal-text": "#1A1A1A",
            "--normal-border": "#E5E5E5",
            "--border-radius": "12px"
          }
      }
      {...props}
      theme={isDark ? "dark" : "light"}
    />
  );
}

export { Toaster }

